import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LanguageType } from '../../api/responses';
import CasePage from '../../components/elements/CasePage';
import Cases from '../../components/elements/Cases';
import TournamentPage from '../../components/elements/TournamentPage';
import Tournaments from '../../components/elements/Tournaments';
import { navigationMenu } from '../../constatnts/navigation';
import { LanguageContext } from '../../context';
import { useGetFilters } from '../../hooks/useGetFilters';

function MainPage() {
  const { data } = useGetFilters();
  const [languages, setLanguages] = useState<LanguageType[]>([]);

  useEffect(() => {
    if (data && data.languages) {
      setLanguages(data.languages);
    }
  }, [data]);

  return (
    <LanguageContext.Provider value={languages}>
      <Routes>
        {navigationMenu.map((item, index) => (
          <Route
            key={index}
            path={!item.type ? '/' : `${item.type}/${item.lang}`}
            element={
              <Cases
                caseType={item.type}
                lang={item.lang}
                title={item.title}
                subTitle={item.subTitle}
              />
            }
          />
        ))}
        {navigationMenu.map((item, index) => (
          <Route
            key={index}
            path={!item.type ? '/:id' : `${item.type}/${item.lang}/:id`}
            element={<CasePage menuTitle={item.title} menuHref={item.href} />}
          />
        ))}
        <Route
          path='*'
          element={
            <div
              style={{
                maxWidth: '200px',
                margin: 'auto',
                textAlign: 'center',
                paddingTop: '40px',
                fontWeight: '700',
              }}
            >
              PAGE NOT FOUND
            </div>
          }
        />
        <Route path='/tournaments' element={<Tournaments />} />
        <Route
          path='/tournaments/:id'
          element={
            <TournamentPage
              menuTitle="Архив турниров"
              menuHref="/tournaments"
            />
          }
        />
      </Routes>
    </LanguageContext.Provider>
  );
}

export default MainPage;
